import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({ providedIn: 'root' })
export class ConfirmService {
    
    constructor(private modal: NzModalService) { }

    show(options: { title?: string; text?: string; subText?: string; yesText?: string; noText?: string }): Promise<boolean> {
        return new Promise((resolve) => {
            this.modal.confirm({
                nzTitle: options.title || 'Confirm',
                nzContent: `
                    <div>
                        <div>${options.text || 'Are you sure?'}</div>
                        ${options.subText ? 
                            `<span class="confirm-dialog-subtext">${options.subText}</span>` 
                            : ''
                        }
                    </div>
                `,
                nzOkText: options.yesText || 'Yes',
                nzCancelText: options.noText || 'No',
                nzCentered: true,
                nzOnOk: () => resolve(true),
                nzOnCancel: () => resolve(false)
            });
        });
    }
}